import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import ErrorHandle from '../../../../common/utils/ErrorHandle';

export default {
	registerProcess({
        commit
    }, data) {
        commit('SET_PAGE', {
            loading: true
        });
        commit('SET_REGISTER', {
            error: '',
            message: '',
            token_hash: '',
            loading: true,
            registered: false
        });
        axios.post(process.env.MIX_API_URL + 'registerUsers', {
                ...data
            })
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => {
                if (data.hasOwnProperty('outcome') && data.outcome.error == 'true') {
                    commit('SET_REGISTER', {
                        error: data.outcome.message,
                        loading: false,
                    });
                    commit('SET_PAGE', {
                        loading: false
                    });
                } else {
                    setTimeout(() => {
                        commit('SET_PAGE', {
                            loading: false
                        });

                        commit('SET_REGISTER', {
                            registered: false,
                            loading: false,
                            message: data.message
                        });
                    }, 2000);
                }
            })
            .catch(e => {
                const { statusCode, error } = new ErrorHandle(e).format;
                if(statusCode == 408) {
                    axios.post(process.env.MIX_API_URL +  'utility/send-failed-api-notification', {
                        'request_uri': 'registerUsers'
                    });
                }
                commit('SET_REGISTER', {
                    token_hash: e.response.data.token_hash,
                    error,
                    loading: false,
                    registered: (error === 'Email address is not verified') ? true : false,
                    message: e.response.data.message
                });
                commit('SET_PAGE', {
                    loading: false
                });
                setTimeout(() => {
                    commit('SET_REGISTER', {
                        registered: false
                    });
                }, 2000);
            });
    },
}